/**
 * Represent panel data loading state.
 */
export enum LoadingState {
    NotStarted = 'NotStarted',
    Loading = 'Loading',
    Streaming = 'Streaming',
    Done = 'Done',
    Error = 'Error',
  }